import React, { useState } from 'react';

const ADMISSIONS_EMAIL = 'bschoolbelur@gmail.com';
const ADMISSIONS_ENDPOINT = process.env.REACT_APP_ADMISSIONS_ENDPOINT || `https://formsubmit.co/ajax/${ADMISSIONS_EMAIL}`;
const emptyForm = {name:'',dob:'',parent:'',phone:'',email:'',class_:''};
const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phonePattern = /^(\+91[\s-]?)?[6-9]\d{9}$/;

export default function AdmissionsPage({ onNav }) {
  const [form, setForm] = useState(emptyForm);
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const handle = (e) => setForm({...form, [e.target.name]: e.target.value});
  const validateForm = () => {
    if (Object.entries(form).some(([, value]) => !value.trim())) {
      return 'Please fill all fields before submitting.';
    }

    if (!emailPattern.test(form.email.trim())) {
      return 'Please enter a valid email address.';
    }

    const phone = form.phone.replace(/[\s-]/g, '');
    if (!phonePattern.test(phone)) {
      return 'Please enter a valid 10 digit Indian phone number.';
    }

    return '';
  };

  const submit = async () => {
    const validationError = validateForm();

    if (validationError) {
      setError(validationError);
      return;
    }

    const application = {
      name: form.name.trim(),
      dob: form.dob,
      parent: form.parent.trim(),
      phone: form.phone.trim(),
      email: form.email.trim(),
      class_: form.class_,
      submittedAt: new Date().toISOString(),
    };

    const savedApplications = JSON.parse(localStorage.getItem('admissionApplications') || '[]');
    localStorage.setItem('admissionApplications', JSON.stringify([...savedApplications, application]));

    setError('');
    setSubmitting(true);

    try {
      if (ADMISSIONS_ENDPOINT) {
        const response = await fetch(ADMISSIONS_ENDPOINT, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            _subject: 'New Admission Application',
            _template: 'table',
            _replyto: application.email,
            'Child Name': application.name,
            'Date of Birth': application.dob,
            'Parent/Guardian': application.parent,
            'Phone': application.phone,
            'Email': application.email,
            'Class Applying For': application.class_,
            'Submitted At': new Date(application.submittedAt).toLocaleString(),
          }),
        });

        if (!response.ok) {
          throw new Error('Could not send the application. Please try again.');
        }
      } else {
        const emailBody = [
          'New admission application',
          '',
          `Child Name: ${form.name}`,
          `Date of Birth: ${form.dob}`,
          `Parent/Guardian: ${form.parent}`,
          `Phone: ${form.phone}`,
          `Email: ${form.email}`,
          `Class Applying For: ${form.class_}`,
          '',
          `Submitted At: ${new Date(application.submittedAt).toLocaleString()}`,
        ].join('\n');

        const mailTo = `mailto:${ADMISSIONS_EMAIL}?subject=${encodeURIComponent('New Admission Application')}&body=${encodeURIComponent(emailBody)}`;
        window.location.href = mailTo;
      }

      setSubmitted(true);
      setTimeout(() => setSubmitted(false), 4000);
      setForm(emptyForm);
    } catch (err) {
      setError(err.message || 'Could not send the application. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <>
      <div className="page-hero">
        <h2>Admissions 2026-2027</h2>
        <p>Begin your child's bright journey with us</p>
      </div>
      <section style={{padding:'70px 0'}}>
        <div className="container">
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'60px',alignItems:'start'}}>
            <div>
              <div className="section-tag">How to Apply</div>
              <h2 className="section-title">Simple 3-Step Admission Process</h2>
              {[['1','Fill the Application','Complete the online or offline application form with your child\'s details and submit.'],
                ['2','Document Verification','Submit required documents — birth certificate, address proof and passport size photo.'],
                ['3','Confirmation','Receive confirmation call from our office and pay the admission fee to secure the seat.']
              ].map(([n,t,d]) => (
                <div key={n} style={{display:'flex',gap:'20px',marginBottom:'28px',alignItems:'flex-start'}}>
                  <div style={{width:'44px',height:'44px',borderRadius:'50%',background:'var(--navy)',color:'#fff',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:'800',fontSize:'18px',flexShrink:0}}>{n}</div>
                  <div><h3 style={{fontFamily:'Poppins',fontWeight:'700',color:'var(--navy)',marginBottom:'6px'}}>{t}</h3><p style={{color:'#555',fontSize:'14px',lineHeight:'1.7'}}>{d}</p></div>
                </div>
              ))}
              <div style={{background:'var(--gray-bg)',borderRadius:'16px',padding:'24px',marginTop:'20px'}}>
                <h4 style={{fontFamily:'Poppins',fontWeight:'700',color:'var(--navy)',marginBottom:'12px'}}>📋 Documents Required</h4>
                <ul style={{listStyle:'none',display:'flex',flexDirection:'column',gap:'8px'}}>
                  {['Birth Certificate (Original)','Aadhar Card (Child)','Parent/Guardian Aadhar','2 Passport-size Photographs','Previous School Records (if any)'].map(d => (
                    <li key={d} style={{fontSize:'14px',color:'#555',display:'flex',alignItems:'center',gap:'8px'}}><span style={{color:'var(--navy)',fontWeight:800}}>✓</span>{d}</li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="contact-form">
              <h3>Apply Now</h3>
              {error && <div style={{background:'#fff4f4',border:'1px solid #f0b5b5',borderRadius:'10px',padding:'14px',marginBottom:'20px',color:'#b42318',fontWeight:'700'}}>{error}</div>}
              {submitted && <div style={{background:'#f8f9fc',border:'1px solid #dbe3f0',borderRadius:'10px',padding:'14px',marginBottom:'20px',color:'var(--navy)',fontWeight:'700'}}>✓ Application submitted! We'll contact you soon.</div>}
              <div className="form-row">
                <div className="form-group"><label>Child's Full Name</label><input name="name" value={form.name} onChange={handle} placeholder="Enter name"/></div>
                <div className="form-group"><label>Date of Birth</label><input name="dob" type="date" value={form.dob} onChange={handle}/></div>
              </div>
              <div className="form-group"><label>Parent/Guardian Name</label><input name="parent" value={form.parent} onChange={handle} placeholder="Enter parent name"/></div>
              <div className="form-row">
                <div className="form-group"><label>Phone Number</label><input name="phone" value={form.phone} onChange={handle} placeholder="+91 XXXXX XXXXX"/></div>
                <div className="form-group"><label>Email Address</label><input name="email" value={form.email} onChange={handle} placeholder="email@example.com"/></div>
              </div>
              <div className="form-group"><label>Class Applying For</label>
                <select name="class_" value={form.class_} onChange={handle}>
                  <option value="">Select class</option>
                  <option>Nursery </option>
                  <option>LKG </option>
                  <option>UKG </option>
                  <option>1st Standard </option>
                  <option>2nd Standard  </option>
                  <option>3rd  Standard</option>
                  <option>4th  Standard</option>
                  <option>5th  Standard</option>
                </select>
              </div>
              <button className="btn-submit" type="button" onClick={submit} disabled={submitting}>{submitting ? 'Submitting...' : 'Submit Application'}</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
